module.exports = __webpack_public_path__ + "static/media/book-medical.47361332.svg";